<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :count='count'
      :current="page"
    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType === 1">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeId" :multiple='true'></storeListSelect>
          </div>
          <div class="queryItem">
            <label>订单编号:</label>
            <lk-input :maxlength="100" placeholder="输入" class="item" clearable v-model.trim="query.orderCode"></lk-input>
          </div>
          <div class="queryItem">
            <label>结算状态:</label>
            <lk-select v-model='query.settlementType' class="item" clearable>
              <lk-option v-for="(item, index) in settleStatus" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label >结算时间:</label>
            <timeStampDatePicker type='daterange' placeholder='请选择' class="item" v-model="query.duration"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns">
          <DownloadButton style="margin-right: 16px;" @on-click="download" v-if="handlePermission('medicalOrderDownload')"></DownloadButton>
          <DownloadButton @on-click="downloadPingAnFo" text="平安佛数据导出" v-if="isGuangdongSocialSecurity"></DownloadButton>
        </div>
        <lk-table border :columns='columns' :data='tableData'/>
      </div>
    </QueryFrame>
    <BeijingInsPayModal
      v-model="BeijingModalRefund"
      :buymode="buymode"
      :orderId="orderId"
      :insuranceId="insuranceId"
      @change="closeBJModal"
    >
    </BeijingInsPayModal>
    <lk-modal
      @on-ok='refund'
      v-model="modalRefund"
      title='撤销结算'
    >
      <p>{{`将撤销${currentOrderNum}的医保结算,是否确认`}}</p>
    </lk-modal>
    <div v-if="isLanZhouStore">
      <lanZhouPrintModel ref='PrintModel' v-show="false"></lanZhouPrintModel>
    </div>
    <div v-if="isUseInsSettleBillPrintModel" v-show="false">
      <haErBinPrintModel ref='PrintModel'></haErBinPrintModel>
    </div>
    <div v-if="isGuangdongSocialSecurity" v-show="false">
      <guangdongPrintModel ref='PrintModel'></guangdongPrintModel>
    </div>
    <div v-if="isShenZhenStore" v-show="false">
      <shenzhenHMBModel ref='HMBPrintModel'></shenzhenHMBModel>
    </div>
    <div v-if="isShenZhenStore" v-show="false">
      <shenzhenPrintModel ref='SZPrintModel'></shenzhenPrintModel>
    </div>
    <lk-modal title="收费单据号" v-model="showInvoicenoModal" :footer-hide='true' width="400">
      <div style="display:flex">
        <span style="color: red;margin-top:6px;margin-left: 15px;margin-right: 3px; font-size: 18px;">*</span>
        <span style="margin-top:8px; font-size: 12px;">收费单据号：</span>
        <lk-input style="margin-left:2px; margin-right: 20px; width: 220px; margin-top: 0px;" placeholder='请输入' :maxlength="200" clearable v-model.trim="invoiceno"></lk-input>
      </div>
      <div class="bottomButton">
          <lk-button type='primary' :disabled="invoiceno == ''" @click="gotoPrint(1)">结算打印</lk-button>
          <lk-button type='primary' :disabled="invoiceno == ''" @click="gotoPrint(2)">退费打印</lk-button>
          <lk-button @click="showInvoicenoModal = false; invoiceno='';">取消</lk-button>
      </div>
    </lk-modal>
    <lk-modal title="请选择打印样式" v-model="showSelectModel" :footer-hide='true' width="400">
      <div style="display:flex; margin-left: 10px; margin-bottom: 30px;">
        <lk-radio-group v-model='printModel' style="margin-left: 20px;">
          <div v-for='item in printModels' style="margin-top: 10px;">
            <lk-radio :key='item.value' :label='item.value'>
            <span>{{item.name}}</span>
          </lk-radio>
          </div>
        </lk-radio-group>
      </div>
      <div class="bottomPrintButton">
          <lk-button type='primary' @click="printClick">打印</lk-button>
          <lk-button @click="showSelectModel=false">取消</lk-button>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import utils from '../../libs/utils';
import storeListSelect from '../../components/StoreListSelect.vue';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';
import sale from '../../services/sale';
import healthInsManage from '../../services/healthInsManage';
import guangdongPrintModel from './guangdongPrintModel.vue';
import lanZhouPrintModel from '../insurance/LanZhou/lanZhouPrintModel.vue';
import haErBinPrintModel from './haErBinPrintModel.vue';
import storeUtils from '../../libs/storeUtil';
import DownloadButton from '../../components/download/DownloadButton.vue';
import BeijingInsPayModal from '../../components/insurance/BeijingInsPayModal.vue';
import bjInsurance from '../../services/bjInsurance';
import shenzhenHMBModel from './shenzhenHMBModel.vue';
import shenzhenPrintModel from './shenzhenPrintModel.vue';

export default {
  name: 'healthInsOrders',
  mixins: [mapState, queryMixins],
  components: {
    storeListSelect,
    QueryFrame,
    lanZhouPrintModel,
    haErBinPrintModel,
    DownloadButton,
    guangdongPrintModel,
    BeijingInsPayModal,
    shenzhenHMBModel,
    shenzhenPrintModel,
  },
  computed: {
    isUseInsSettleBillPrintModel() {
      return storeUtils.isUseInsSettleBillPrintModel(this.$store.state.storeInfo.id);
    },
    isLanZhouStore() {
      return this.$store.state.storeInfo.id === storeUtils.lanzhou.id;
    },
    isGuangdongSocialSecurity() {
      return storeUtils.isGuangdongSocialSecurity(this.$store.state.storeInfo.id);
    },
    isShenZhenStore() {
      return [62].indexOf(this.$store.state.storeInfo.id) >= 0;
    },
  },
  data() {
    return {
      showSelectModel: false,
      printModel: 0,
      printParams: {},
      printOrderId: '',
      printModels: [
        {
          value: 0,
          name: '医保结算单（针式二联纸）',
        },
        {
          value: 1,
          name: '医保结算单（A4）',
        },
        {
          value: 2,
          name: '惠民保结算单（A4）',
        },
      ],
      query: {},
      settleStatus: [
        {
          value: 3,
          name: '已撤销',
        },
        {
          value: 2,
          name: '正常',
        },
      ],
      currentOrderNum: '',
      currentOrderParam: {},
      modalRefund: false,
      BeijingModalRefund: false,
      szPrint: {
        pay: {},
        receipt: {
          saleOrder: {},
          saleOrderDetailList: [],
        },
      },
      columns: [
        {
          type: 'index',
          title: '序号',
          width: 60,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 140,
        },
        {
          title: '订单编号',
          key: 'orderCode',
          minWidth: 140,
        },
        {
          title: '结算ID',
          key: 'medicalCode',
          minWidth: 116,
        },
        {
          title: '人员编号',
          key: 'psnNo',
          minWidth: 116,
        },
        {
          title: '结算状态',
          key: 'settlementTypeName',
          minWidth: 116,
          render: (h, params) => h('span', { style: { color: params.row.settlementType == 5 || params.row.settlementType == 7 ? 'red' : '' } }, params.row.settlementTypeName || ''),
        },
        {
          title: '对账状态',
          key: 'accountStatusName',
          minWidth: 116,
          render: (h, params) => h('span', { style: { color: params.row.accountStatus == 0 ? 'red' : '' } }, params.row.accountStatusName || ''),
        },
        {
          title: '患者姓名',
          key: 'patientName',
          minWidth: 116,
        },
        {
          title: '医保科目',
          key: 'medicalSubjectName',
          minWidth: 116,
        },
        {
          title: '卡类型',
          key: 'cardTypeName',
          minWidth: 116,
        },
        {
          title: '人员类型',
          key: 'personTypeName',
          minWidth: 116,
        },
        {
          title: '结算时间',
          key: 'settlementTime',
          minWidth: 116,
        },
        {
          title: '医疗费总额',
          key: 'orderAmount',
          minWidth: 116,
        },
        {
          title: '基金支付总额',
          key: 'medicalSettlementAmount',
          minWidth: 116,
        },
        {
          title: '个人账户支出',
          key: 'personAmount',
          minWidth: 116,
        },
        {
          title: '个人自费',
          key: 'personPay',
          minWidth: 116,
        },
        {
          title: '公务员补助',
          key: 'civilServiceSubsidyTotalAmout',
          minWidth: 116,
        },
        {
          title: '大病补助',
          key: 'entryIntoSeriousIllnessFee',
          minWidth: 116,
        },
        {
          title: '清算类别',
          key: 'clrTypeName',
          minWidth: 116,
        },
        {
          title: '险种类别',
          key: 'insutypeName',
          minWidth: 116,
        },
        {
          title: '操作',
          fixed: 'right',
          minWidth: 200,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'salesOrderCheck', params: { id: params.row.orderId } });
                },
              },
            }, '查看'),
            params.row.settlementType === 2 && params.row.status != '失败' ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  const storeId = params.row.storeId;
                  if (params.row.storeId == 7) {
                    this.BeijingModalRefund = true;
                    this.orderId = params.row.orderId;
                    this.buymode = params.row.buymode;
                    this.insuranceId = params.row.id;
                    return;
                  }
                  this.modalRefund = true;
                  this.currentOrderParam = {
                    id: params.row.id,
                    setlId: params.row.setlId,
                    mdtrtId: params.row.mdtrtId,
                    psnNo: params.row.psnNo,
                    orderId: params.row.orderId,
                    insuAdmdvs: params.row.insuAdmdvs,
                  };
                  this.currentOrderNum = params.row.orderCode;
                },
              },
            }, '撤销结算') : '',
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  if (this.isLanZhouStore) {
                    this.toPrintLanZhou(params.row.orderId);
                    return;
                  }
                  if (params.row.storeId == 7) { // 北京门店
                    this.orderId = params.row.orderId;
                    this.invoiceno = '';
                    this.showInvoicenoModal = true;
                    return;
                  }
                  const obj = params.row;
                  const param = {
                    psnNo: obj.psnNo,
                    setlId: obj.setlId,
                    mdtrtId: obj.mdtrtId,
                  };
                  if (this.isShenZhenStore) {
                    this.printParams = param;
                    this.printOrderId = params.row.orderId;
                    this.printModel = 0;
                    this.showSelectModel = true;
                    return;
                  }
                  this.toPrint(param);
                },
              },
            }, '打印'),
            params.row.storeId != 7 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'settleInfo', query: { mdtrtId: params.row.mdtrtId, setlId: params.row.setlId, psnNo: params.row.psnNo } });
                },
              },
            }, '结算信息') : '',
            params.row.settlementType == 5 || params.row.settlementType == 7 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.rectification(params.row.orderId);
                },
              },
            }, '挂起回退') : '',
            params.row.accountStatus == 0 && params.row.storeId == 7 ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.finishedNotice(params.row.orderId);
                },
              },
            }, '实时对账') : '',
          ]),
        },
      ],
      tableData: [],
      buymode: null, // 北京医保购药方式
      orderId: null, // 北京医保订单id
      invoiceno: '', // 北京医保
      showInvoicenoModal: false,
      insuranceId: '',
    };
  },
  methods: {
    rectification(orderId) { // 挂起回退
      healthInsManage.rectification({ orderId }).then((res) => {
        if (res.data.status === 200) {
          this.handleSearch();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    finishedNotice(orderId) { // 实时对账
      healthInsManage.finishedNotice({ orderId }).then((res) => {
        if (res.data.status === 200) {
          this.handleSearch();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    gotoPrint(type) {
      this.showInvoicenoModal = false;
      const param = { orderId: this.orderId, invoiceno: this.invoiceno, setlFlag: type };
      this.toPrintBeijing(param);
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.duration && this.params.duration.length) {
        this.params.beginTime = this.params.duration[0];
        this.params.endTime = this.params.duration[1];
        delete this.params.duration;
      }
      healthInsManage.getOrders(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = res.data.data.list || [];
          this.tableData.forEach((item) => {
            if (item.settlementTime) {
              item.settlementTime = utils.exchangeTimeToSecond(item.settlementTime);
            } else {
              item.settlementTime = '';
            }
          });
          this.count = res.data.data.count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    refund() {
      healthInsManage.retreatOrder(this.currentOrderParam).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('撤销成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {
        duration: [],
      };
    },
    toPrint(params) {
      healthInsManage.getSettlementInfo(params).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data instanceof Object) {
            res.data.data.printTime = utils.formatTime(new Date().getTime());
            this.$refs.PrintModel.tableData = res.data.data;
            this.$nextTick(() => {
              this.$refs.PrintModel.handlePrint();
            });
          } else {
            this.$Message.error('数据格式错误');
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toHMBPrint(params) {
      healthInsManage.getExpenseInfo(params).then((res) => {
        if (res.data.status === 200) {
          this.$refs.HMBPrintModel.tableData = res.data.data;
          this.$nextTick(() => {
            this.$refs.HMBPrintModel.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toPrintLanZhou(id) {
      sale.getOrderAllById({ id }).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.insurance && (res.data.data.insurance instanceof Object)) {
            const insuranceInfo = res.data.data.insurance;
            const time = insuranceInfo.modifiedTime || '';
            insuranceInfo.modifiedTime = time ? utils.formatDate(time) : '';
            this.$refs.PrintModel.tableData = res.data.data.insurance;
            this.$nextTick(() => {
              this.$refs.PrintModel.handlePrint();
            });
          } else {
            this.$Message.error('医保数据格式错误, 请重试');
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.duration && params.duration.length) {
        params.beginTime = params.duration[0];
        params.endTime = params.duration[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      healthInsManage.exportOrder(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    downloadPingAnFo() {
      const params = Object.assign({}, this.query);
      if (params.duration && params.duration.length) {
        params.beginTime = params.duration[0];
        params.endTime = params.duration[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      healthInsManage.pinganfoExportData(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 北京医保打印
    toPrintBeijing(params) {
      bjInsurance.printInvocie(params)
        .then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('打印成功');
            if (res.data.data.detailreprintflag === 1) {
              this.$Message.info('药店需要另行打印明细');
            }
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    isBeijingStore(storeId) {
      return storeUtils.bjlink.id === storeId; // 目前仅北京邻客支持
    },
    closeBJModal(e) {
      this.BeijingModalRefund = e;
    },
    getSettlementInfo(params) {
      return new Promise((resolve) => {
        healthInsManage.getSettlementInfo(params).then((res) => {
          if (res.data.status === 200) {
            this.szPrint.pay = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          resolve(err);
          utils.handleError(err);
        });
      });
    },
    getOrderAllById(id) {
      return new Promise((resolve) => {
        sale.getOrderAllById({ id }).then((res) => {
          if (res.data.status === 200) {
            this.szPrint.receipt = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          resolve(err);
          utils.handleError(err);
        });
      });
    },
    toPrintSZ(params, id) {
      Promise.all([
        this.getSettlementInfo(params),
        this.getOrderAllById(id),
      ]).then(() => {
        this.$refs.SZPrintModel.tableData = this.szPrint;
        this.$nextTick(() => {
          this.$refs.SZPrintModel.handlePrint();
        });
      });
    },
    printClick() {
      this.showSelectModel = false;
      if (this.printModel == 0) {
        this.toPrintSZ(this.printParams, this.printOrderId);
      } else if (this.printModel == 1) {
        this.toPrint(this.printParams);
      } else if (this.printModel == 2) {
        this.toHMBPrint(this.printParams);
      }
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
  .bottomButton{
    margin-left: 100px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}
.bottomPrintButton{
    margin-left: 223px;
    margin-top: 20px;
    >*{margin-right: 16px
  }
}
</style>
